import { Pipe, PipeTransform } from '@angular/core';

import { CYCLE_EXCEPTIONS } from '@app/new-cycle/cycle-exceptions';

@Pipe({ name: 'cycleExceptionNew' })
export class NewCycleExceptionPipe implements PipeTransform {
  public transform(value, name, exactMatch = false) {
    const text = CYCLE_EXCEPTIONS[name];
    if (exactMatch) {
      if (value === true) {
        return text[1];
      } else if (value === false) {
        return text[0];
      } else {
        return '';
      }
    } else {
      return value ? text[1] : text[0];
    }
  }
}
